import React, {useEffect, useState} from "../_snowpack/pkg/react.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {useForm} from "../_snowpack/pkg/react-hook-form.js";
import {
  AlertVariant,
  PageSection,
  PageSectionVariants
} from "../_snowpack/pkg/@patternfly/react-core.js";
import {useAlerts} from "../components/alert/Alerts.js";
import {
  AttributesForm
} from "../components/attribute-form/AttributeForm.js";
import {
  attributesToArray,
  arrayToAttributes
} from "../components/attribute-form/attribute-convert.js";
import {useAdminClient} from "../context/auth/AdminClient.js";
export const UserAttributes = ({user: defaultUser}) => {
  const {t} = useTranslation("users");
  const adminClient = useAdminClient();
  const {addAlert, addError} = useAlerts();
  const [user, setUser] = useState(defaultUser);
  const form = useForm({mode: "onChange"});
  const convertAttributes = (attr) => {
    return attributesToArray(attr || user.attributes);
  };
  useEffect(() => {
    form.setValue("attributes", convertAttributes());
  }, [user]);
  const save = async (attributeForm) => {
    try {
      const attributes = arrayToAttributes(attributeForm.attributes);
      await adminClient.users.update({id: user.id}, {...user, attributes});
      setUser({...user, attributes});
      addAlert(t("userSaved"), AlertVariant.success);
    } catch (error) {
      addError("groups:groupUpdateError", error);
    }
  };
  return /* @__PURE__ */ React.createElement(PageSection, {
    variant: PageSectionVariants.light
  }, /* @__PURE__ */ React.createElement(AttributesForm, {
    form,
    save,
    reset: () => form.reset({
      attributes: convertAttributes()
    })
  }));
};
